import { AppRouteRecordRaw } from '@/router/types'

export const cpsFinancial: AppRouteRecordRaw[] = [
  {
    path: 'cpsFinancial',
    name: 'CpsFinancial',
    redirect: '/cpsFinancial/storeAccountManage',
    meta: {
      title: 'CPS财务管理'
    },
    children: [
      {
        path: 'storeAccountManage',
        name: 'StoreAccountManage',
        component: () => import('@/views/cpsFinancial/storeAccountManage/index.vue'),
        meta: {
          title: '门店账户管理'
        }
      },

      {
        path: 'storeSettlement',
        name: 'StoreSettlement',
        component: () => import('@/views/cpsFinancial/storeSettlement/index.vue'),
        meta: {
          title: '门店结算'
        },
        children: []
      },

      {
        path: 'userChargeDetail',
        name: 'UserChargeDetail',
        component: () => import('@/views/cpsFinancial/userChargeDetail/index.vue'),
        meta: {
          title: '用户费用明细'
        },
        children: []
      },

      {
        path: 'storeSettlementForm',
        name: 'StoreSettlementForm',
        component: () => import('@/views/cpsFinancial/storeSettlementForm/index.vue'),
        meta: {
          title: '门店结算单'
        }
      }
    ]
  }
]
